export const LOCAL_STORAGE_KEYS = {
  DISMISSED_UPDATES: 'dismissedUpdates',
  WIDGET_BUILDER: 'widgetBubble_',
  DRAFT_MESSAGES: 'draftMessages',
  COLOR_SCHEME: 'color_scheme',
  DISMISSED_LABEL_SUGGESTIONS: 'labelSuggestionsDismissed',
  /** Overview Priority Leads segment selection: `chatwoot_priority_leads_filters_${accountId}` */
  PRIORITY_LEADS_FILTERS_PREFIX: 'chatwoot_priority_leads_filters_',
};
